import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

@Component({
   selector: 'app-footer',
   templateUrl: './footer.component.html',
   // styleUrls: ['./header.component.scss']
 })
 export class FooterComponent implements OnInit {
    timeZone = '';
    utcDateTime: Date;
    localDateTime: Date;
    constructor() {
       this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
       this.utcTime();
    }

    ngOnInit() {
    }

    utcTime(): void {
       setInterval(() => {
           const today = new Date();
           this.localDateTime = today;
           this.utcDateTime = new Date(today.getTime() + (today.getTimezoneOffset() * 60000));
       }, 1000);
    }
 }
